import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import PublishProduct from './pages/PublishProduct';
import ProductDetail from './pages/ProductDetail';
import Chat from './pages/Chat';
import Products from './pages/Products';
import Profile from './pages/Profile';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';

// Crear tema personalizado
const theme = createTheme({
  palette: {
    primary: {
      main: '#1e3a8a',
    },
    secondary: {
      main: '#f59e0b',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/publish-product" element={<PublishProduct />} />
              {/* Aquí agregaremos más rutas cuando creemos los componentes */}
              <Route path="/products" element={<Products />} />
              <Route path="/rfq" element={<div>Página de RFQ (Próximamente)</div>} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/dashboard" element={<div>Dashboard (Próximamente)</div>} />
              <Route path="/products/:id" element={<ProductDetail />} />
            </Routes>
          </Layout>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
